import { EComparaisonLQ } from "src/app/domain/enum/comparaison-lq";
import { ELimitValueType } from "src/app/domain/enum/limit-value-type";
import { EUserType } from "src/app/domain/enum/user-type";

export class StringConverter {

    static getConfirmMessageByLabel(label: string) {
        switch (label) {
            case 'confirm-removal-generic':
                return 'Etes-vous sûr de vouloir supprimer cet élément ?';
            case 'confirm-removal-strategy':
                return 'Etes-vous sûr de vouloir supprimer cette stratégie ?';
            default:
                return 'Not Set';
        }
    }

    static getUserTypeName(status: EUserType) {
        switch (status) {
            case EUserType.None:
                return 'Inconnu';
            case EUserType.Gestionnaire:
                return 'Gestionnaire';
            case EUserType.Standard:
                return 'Utilisateur';
            case EUserType.Administrateur:
                return 'Admin';
            default:
                return 'Not Set';
        }
    }

    static getLimitValueTypeName(freq: ELimitValueType) {
        switch (freq) {
            case ELimitValueType.Inferieur:
                return '<';
            case ELimitValueType.InferieurOuEgal:
                return '<=';
            case ELimitValueType.Egal:
                return '=';
            case ELimitValueType.SuperieurOuEgal:
                return '>=';
            case ELimitValueType.Superieur:
                return '>';
            default:
                return 'Not Set';
        }
    }

    static getComparaisonLQName(freq: EComparaisonLQ) {
        switch (freq) {
            case EComparaisonLQ.LQ:
                return 'LQ';
            case EComparaisonLQ.Zero:
                return '0';
            default:
                return 'Not Set';
        }
    }
}
